"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.raceSignals = exports.createAbortControllerLike = exports.hasNativeAbortController = exports.AbortControllerMicrofill = exports.AbortSignalMicrofill = void 0;
var tslib_1 = require("tslib");
var emitter_1 = require("@spotify-internal/emitter/es5");
var AbortSignalMicrofill = /** @class */ (function (_super) {
    tslib_1.__extends(AbortSignalMicrofill, _super);
    function AbortSignalMicrofill() {
        var _this = _super.call(this) || this;
        _this._aborted = false;
        _this.onabort = null;
        _this.on('abort', function () { var _a; return (_a = _this.onabort) === null || _a === void 0 ? void 0 : _a.call(_this); });
        return _this;
    }
    /**
     * Returns a new AbortSignalMicrofill that is already in an aborted state.
     *
     * @returns A new AbortSignalMicrofill instance that is already in an aborted state.
     */
    AbortSignalMicrofill.abort = function () {
        var signal = new AbortSignalMicrofill();
        signal._aborted = true;
        return signal;
    };
    /**
     * Non-standard method for aborting an AbortSignalLike.
     *
     * If the signal instance passed is an AbortSignalMicrofill, this function
     * will abort the signal and emit the event. Otherwise it'll be a noop.
     *
     * @param signal - Either an AbortSignalLike or an AbortSignalMicrofill instance.
     */
    AbortSignalMicrofill.signalAbort = function (signal) {
        if ('_aborted' in signal && !signal._aborted) {
            signal._aborted = true;
            signal.emit('abort', null);
        }
    };
    Object.defineProperty(AbortSignalMicrofill.prototype, "aborted", {
        get: function () {
            return this._aborted;
        },
        set: function (_value) { },
        enumerable: false,
        configurable: true
    });
    AbortSignalMicrofill.prototype.addEventListener = function (type, listener) {
        this.addListener(type, listener);
    };
    AbortSignalMicrofill.prototype.removeEventListener = function (type, listener) {
        this.removeListener(type, listener);
    };
    AbortSignalMicrofill.prototype.dispatchEvent = function () { };
    return AbortSignalMicrofill;
}(emitter_1.EventEmitter));
exports.AbortSignalMicrofill = AbortSignalMicrofill;
/**
 * A small AbortController polyfill that implements the AbortControllerLike interface.
 */
var AbortControllerMicrofill = /** @class */ (function () {
    function AbortControllerMicrofill() {
        /**
         * Returns the AbortSignal object associated with this object.
         */
        this.signal = new AbortSignalMicrofill();
    }
    /**
     * Invoking this method will set this object's AbortSignal's aborted flag and
     * signal to any observers that the associated activity is to be aborted.
     */
    AbortControllerMicrofill.prototype.abort = function () {
        var signal = this.signal;
        AbortSignalMicrofill.signalAbort(signal);
    };
    return AbortControllerMicrofill;
}());
exports.AbortControllerMicrofill = AbortControllerMicrofill;
/**
 * Returns whether the platform has a native AbortController.
 *
 * @returns True if the platform has a native AbortController, false otherwise.
 */
function hasNativeAbortController() {
    return (typeof window !== 'undefined' &&
        typeof window.AbortController === 'function');
}
exports.hasNativeAbortController = hasNativeAbortController;
/**
 * Returns a Transport compatible AbortControllerLike object.
 *
 * @returns For platforms that natively support AbortController, this will
 *   return a native AbortController object. Otherwise, this will return a
 *   compatible AbortController microfill.
 */
exports.createAbortControllerLike = hasNativeAbortController()
    ? function () { return new AbortController(); }
    : function () { return new AbortControllerMicrofill(); };
/**
 * Takes in multiple signals and combines them into a single signal that will be
 * aborted if any of the provided signals are aborted.
 *
 * @param signals - An array of signals to observe.
 * @returns A new signal that would be aborted if any of the provided signals are aborted.
 */
function raceSignals(signals) {
    var controller = exports.createAbortControllerLike();
    // Operate on a copy of the signals to ensure that changes to the array
    // argument do not change the function.
    var _signals = tslib_1.__spreadArray([], signals);
    var onAbort = function () {
        // Clean up all listeners.
        for (var _i = 0, _signals_1 = _signals; _i < _signals_1.length; _i++) {
            var signal = _signals_1[_i];
            signal.removeEventListener('abort', onAbort);
        }
        controller.abort();
    };
    for (var _i = 0, _a = tslib_1.__spreadArray([], signals); _i < _a.length; _i++) {
        var signal = _a[_i];
        signal.addEventListener('abort', onAbort);
    }
    return controller.signal;
}
exports.raceSignals = raceSignals;
//# sourceMappingURL=abortcontroller.js.map